import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import TornPaperWrapper from '../components/TornPaperWrapper';
import './LoginPage.css';
import { getCmsImagePath } from '../cms/cmsData';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await api.requestPasswordReset(email);
      if (response?.success) {
        setSubmitted(true);
        setMessage(response.message || 'If an account exists with this email, you will receive a password reset link.');
      } else {
        setError(response?.error?.message || 'Failed to send reset email');
      }
    } catch (err) {
      // Always show success to prevent email enumeration
      setSubmitted(true);
      setMessage('If an account exists with this email, you will receive a password reset link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <AnnouncementBar />
      
      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video src={"/hero-final.mp4"} alt="oc mena festival" className="hero-background-video" autoPlay muted loop playsInline />
          <div className="hero-gradient-overlay"></div>
        </div>

        <TornPaperWrapper>
          <h1 className="card-title" style={{ paddingBottom: '30px' }}>Reset Password</h1>

          {submitted ? (
            <div className="reset-success">
              <div style={{ textAlign: 'center', padding: '2rem 0' }}>
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto 1rem' }}>
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#333', marginBottom: '1rem' }}>Check Your Email</h2>
                <p style={{ color: '#666', marginBottom: '2rem' }}>{message}</p>
                <Link to="/login" className="btn-primary submit-btn" style={{ display: 'inline-block', textDecoration: 'none' }}>
                  Return to Login
                </Link>
              </div>
            </div>
          ) : (
            <>
              <p style={{ textAlign: 'center', color: '#666', marginBottom: '2rem' }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>

              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <div className="email-input-wrapper">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder=""
                      autoComplete="email"
                      autoCapitalize="none"
                      autoCorrect="off"
                      spellCheck="false"
                      required
                    />
                  </div>
                </div>

                {error && <div className="error-message" style={{color: '#e74c3c', marginBottom: '1rem', textAlign: 'center'}}>{error}</div>}

                <button type="submit" className="btn-primary submit-btn" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
                
                <div className="forgot-password-left" style={{ marginTop: '1rem' }}>
                  <Link to="/login" className="forgot-link-grey">Back to Login</Link>
                </div>
              </form>
            </>
          )}
        </TornPaperWrapper>

        <div className="lanterns-container">
          <img loading="lazy" src={getCmsImagePath("lanterns", "/lanterns.webp")} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ForgotPassword;
